<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                        <div>
                            <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                        </div>
                        <div class="d-flex flex-column ga-2">
                            <div class="text-h5 font-weight-bold text-darkblue">Dashboard des campagnes d'emails
                            </div>
                            <div>Cette interface vous permet de créer et de gérer les campagnes d'emails du module.
                            </div>
                            <div class="d-flex ga-2 flex-wrap">
                                <SportipsButton icon="mdi-account-details" chevron toPage="MailingCreateContactListing">
                                    Créer
                                    une liste de destinataires</SportipsButton>
                                <SportipsButton icon="mdi-email" chevron toPage="MailingCreateCampaign">Créer une
                                    campagne</SportipsButton>
                            </div>
                            <ListContactsListing></ListContactsListing>
                            <ListMailingCampaigns></ListMailingCampaigns>
                        </div>

                    </div>


                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import ListContactsListing from "@/components/Administration/MailingSystem/ListContactsListing.vue";
import ListMailingCampaigns from "@/components/Administration/MailingSystem/ListMailingCampaigns.vue";
export default {
    components: { ListContactsListing, ListMailingCampaigns },

}
</script>


<style lang="scss" scoped></style>